module.exports = __webpack_public_path__ + "img/tie.8542c551.svg";